import { render, staticRenderFns } from "./PatIndex.vue?vue&type=template&id=eabac922&scoped=true"
import script from "./PatIndex.vue?vue&type=script&lang=js"
export * from "./PatIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabac922",
  null
  
)

export default component.exports